<template>
  <NumeraiModal
    ref="modal"
    :dialog="dialog"
    :button="false"
    title="Diagnostics Logs"
    :width="2000"
    :show-footer="false"
    @close="onClose"
  >
    <p v-if="errorDescription" class="color-error my-5">
      <strong>ERROR: {{ errorDescription }}</strong>
    </p>
    <div v-if="loading" class="mt-5">
      <NumeraiLoader text="Loading" />
    </div>
    <table v-if="logs && logs.length" class="mt-8 mb-8">
      <thead>
        <tr>
          <th class="timestamp">Timestamp</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(log, index) in formattedLogs">
          <tr :key="index">
            <td>{{ formatTimestamp(log.timestamp) }}</td>
            <td>{{ log.message }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-else-if="errorMessage" class="mt-5 numerai-form-error">
      {{ errorMessage }}
    </div>
    <div v-else class="mt-5">
      <p>No logs available</p>
    </div>
    <div class="flexrow justify_end">
      <button class="numerai-button button-tertiary" @click="onClose">
        Close
      </button>
      <button
        v-if="logs && logs.length"
        class="numerai-button"
        @click="downloadJSON"
      >
        Download JSON
      </button>
    </div>
  </NumeraiModal>
</template>

<script>
import moment from 'moment'

export default {
  components: {
    NumeraiModal: () => import('@/components/shared/NumeraiModal'),
    NumeraiLoader: () => import('@/components/shared/NumeraiLoader'),
  },
  props: {
    dialog: { type: Boolean, default: false },
    onClose: { type: Function, default: null },
    pickleId: { type: String, default: null },
    errorDescription: { type: String, default: null },
  },
  data() {
    return {
      logs: null,
      loading: false,
      errorMessage: null,
    }
  },
  computed: {
    formattedLogs() {
      if (!this.logs) {
        return
      }
      return [...this.logs].sort((a, b) => a.timestamp - b.timestamp)
    },
  },
  watch: {
    pickleId(newVal) {
      newVal && this.fetchDiagnosticsLogs(newVal)
    },
  },
  methods: {
    async fetchDiagnosticsLogs(pickleId) {
      this.loading = true
      this.errorMessage = null
      try {
        this.logs = await this.$client.getDiagnosticsLogs(pickleId)
      } catch (e) {
        this.errorMessage = e.message
      } finally {
        this.loading = false
      }
    },
    formatTimestamp(timestamp) {
      return moment(timestamp, 'x').format('L LTS')
    },
    downloadJSON() {
      const dataStr =
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(this.logs))
      const downloadAnchorNode = document.createElement('a')
      downloadAnchorNode.setAttribute('href', dataStr)
      downloadAnchorNode.setAttribute('download', 'logs.json')
      document.body.appendChild(downloadAnchorNode) // required for firefox
      downloadAnchorNode.click()
      downloadAnchorNode.remove()
    },
  },
}
</script>

<style scoped>
th {
  text-align: left;
}

td {
  font-family: monospace;
  vertical-align: top;
  padding-bottom: 10px;
}

.timestamp {
  width: 200px;
}
</style>
